<script lang="ts">
    import src from './svg/help_24dp_000000_FILL0_wght400_GRAD0_opsz24.svg';
    import TemplateIcon from './TemplateIcon.svelte';
    export let scale: number = 1;
    export let hover: string = '';
</script>

<TemplateIcon {src} {scale} alt="Help" on:click {hover} />
